module.exports = __webpack_public_path__ + "static/security3@3x-12236ccd2486b32e2c33811462dd30b9.png";